export const RoutePaths = {
    /* Root */
    Root: '/',

    /* Create Account */
    SignUp: ["/sign-up", "/create-your-account", "/CreateYourAccount", "/TruthSeeker", "/GameChanger"],
    SignUpSuccess: "/sign-up-success",

    /* Subscription Routes */
    PreSignUp: "/question-everything",
    ChoosePlan: "/choose-plan",
    ConfirmSubscription: "/ConfirmSubscription",
    Renew: "/Renew",
    Renew3DSConfirm: "/Renew3DSConfirm",

    /* Article Routes */
    BrowseArticles: "/Read",
    ArticleCategory: (id : number | ':id') => {return "/Read/Categories/" + id},
    ReadArticle: (id: number | string |  ':id') => {return "/Read/r/" + id},
    ReadArticleOld: (id: number | string | ':id') => {return "/news-read/r/" + id},

    /* Video Player Routes */
    WatchTrailer: (id: number | ':id') => {return "/Watch/t/" + id},
    Watch: (id: number | ':id') => { return "/Watch/" + id },
    SeriesTrailer: (id: number | ':id') => { return "/Series/t/" + id },

    /* Marketing Landing Pages */
    LifetimeMembership: "/lp/lifetime-membership",

    /* Navigation */
    Browse: "/Browse",
    Series: "/Series",
    Films: "/Films",
    SeriesEpisodes: (id: number | ':id') => { return "/Series/" + id},
    WeeklyShows: ["/WeeklyShows", "/News"],
    Category: (id: number | ':id') => { return "/Categories/" + id},
    Event: (id: number | ':id') => { return "/Event/" + id},
    Affiliate: (link: string | ':link') => { return "/Affiliate/" + link},

    /* Reporting */
    Reports:"/Reports",
    CommentModeration: "/Comments/Moderation",

    /* Support & TOS */
    HelpCentre: "/HelpCentre",
    TermsOfUse: "/TermsOfUse",
    PrivacyPolicy: "/PrivacyPolicy",
    Careers: "/Careers",

    /* Account */
    Login: "/login",
    Account: "/Account",
    ForgotPassword: "/ForgotPassword",
    ResetPassword: (userId: string | ':userId', code: string | ':code') => { return "/ResetPassword/" + userId + "/" + code},

    /* TV Authentication */
    Activate: 'Activate',
    GenericTvAuth: "TvLogin",
    Roku: "/Roku",
    Firestick: "/Firestick",
    AndroidTV: "/AndroidTV",
    SamsungTV: "/SamsungTV",

    /* Additional Routes */
    Wtaf: "/WTAF",
    RightNow: "/RightNow",
    DotConnector: "/DotConnector",
    IsNowTheTime: "/IsNowTheTime",
    TheDotConnector: "/TheDotConnector",
    DavidIcke: "/DavidIcke",
    DavidIckeFilms: "/DavidIcke/Films",
    DavidIckeLive: "/DavidIcke/Live",
    DavidIckeSeries: "/DavidIcke/Series",
};


export const ExternalURLs = {
    /* External Resources */
    Shop: "https://shop.ickonic.com/",
    Forum: "https://forum.ickonic.com/"
}

export const URLsWithoutUI = [
    /^\/sign-up/,
    /^\/question-everything/,
    /^\/create-your-account/,
    /^\/sign-up-success/,
    /^\/login/,
    // Password reset: strip the marketing header/footer (which surface Sign Up /
    // Subscribe CTAs). Reachable from the Firestick login flow, so it must stay
    // purchase-link-free for Amazon Appstore IAP review.
    /^\/ForgotPassword/i,
    /^\/ResetPassword/i,
    /^\/CreateYourAccount/,
    /^\/choose-plan/,
    /^\/Renew/,
    /^\/ConfirmSubscription/,
    /^\/lp\/lifetime-membership$/,
    /^\/TruthSeeker/,
    /^\/GameChanger/,
    // Firestick activation: no global header/footer (no Sign Up / Subscribe nav
    // links) to satisfy Amazon Appstore IAP review.
    /^\/Firestick/i
]

export const URLsWithNotifyBar = [
    /^\/Browse/,
    /^\/Series/,
    /^\/Films/,
    /^\/WeeklyShows/,
    /^\/Read/,
    /^\/DavidIckeRoot/
]

export function createLoginPath(redirectTo?: string) {
    return "/login" + (redirectTo ?? "");
}
